import { useMemo } from "react";

import { useMachineGroups } from "@/hooks/machine-groups";
import { useMachines } from "@/hooks/machines/use-machines";
import type { Machine } from "@/schemas/machine";

import { type ConfiguredMachines, MachineGroupsTemplate } from "./machine-groups.template";

export const MachineGroups = () => {
	const { machineGroups, isLoading, error, refresh } = useMachineGroups({ refetchInterval: false });
	const { machines } = useMachines({ refetchInterval: false });

	const machineList = useMemo<Machine[]>(() => (machines ?? []) as Machine[], [machines]);

	const configuredMachines = useMemo<ConfiguredMachines>(() => {
		if (!machineGroups?.length || !machineList.length) {
			return {};
		}

		return machineGroups.reduce<ConfiguredMachines>((acc, machineGroup) => {
			if (
				!machineGroup.configuredMachinesWithMachineType ||
				Object.keys(machineGroup.configuredMachinesWithMachineType).length === 0
			) {
				return acc;
			}

			const machineNames = Object.keys(machineGroup.configuredMachinesWithMachineType)
				.map((id) => machineList.find((machine) => machine.id === id)?.alias || "")
				.filter(Boolean);

			acc[machineGroup.id] = machineNames;
			return acc;
		}, {});
	}, [machineGroups, machineList]);

	return (
		<MachineGroupsTemplate
			machineGroups={machineGroups ?? []}
			configuredMachines={configuredMachines}
			machineList={machineList}
			isLoading={isLoading}
			isError={Boolean(error)}
			onRetry={refresh}
		/>
	);
};
